import Box from "@mui/material/Box";
import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { TextView } from "@components";
import Images from "./Images";
import PermMediaOutlinedIcon from "@mui/icons-material/PermMediaOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import HeadsetOutlinedIcon from "@mui/icons-material/HeadsetOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import Videos from "./Videos";
import Attachments from "./Attachments";
import Audios from "./Audios";
import { ReactComponent as LinksIconMobile } from "../../../../assets/images/links-icon-mobile.svg";
import Links from "./Links";

export default function MediaBox({ values }) {
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <TextView variant="text" style={{ fontSize: "8px" }}>
              {children}
            </TextView>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const tabStyle = {
    width: "20%",
    minWidth: 0,
    // padding: "6px 0",
  };

  const iconStyle = {
    fontSize: {
      xs: "4vw",
      sm: "17vw",
      md: "1.5vw",
      lg: "1.25vw",
    },
  };

  const [tabvalue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  return (
    <Box
      sx={{
        // width: "95vw",
        backgroundColor: "#F6F7F9",
        borderRadius: "10px",
        margin: "10px",
        padding: "10px",
        paddingBottom: tabvalue === 4 ? "5px" : "0px",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabvalue}
          onChange={handleTabChange}
          aria-label="basic tabs example"
          variant="scrollable" // Add this line to make tabs scrollable on smaller screens
          scrollButtons="auto" // Add this line to have scroll buttons automatically appear
        >
          <Tab
            sx={tabStyle}
            icon={<PermMediaOutlinedIcon sx={iconStyle} />}
            {...a11yProps(0)}
          />
          <Tab
            sx={tabStyle}
            icon={<PlayCircleOutlineOutlinedIcon sx={iconStyle} />}
            {...a11yProps(1)}
          />
          <Tab
            sx={tabStyle}
            icon={<HeadsetOutlinedIcon sx={iconStyle} />}
            {...a11yProps(2)}
          />
          <Tab
            sx={tabStyle}
            icon={<AttachFileOutlinedIcon sx={iconStyle} />}
            {...a11yProps(3)}
          />
          <Tab
            sx={tabStyle}
            icon={<LinksIconMobile sx={iconStyle} />}
            {...a11yProps(3)}
          />
        </Tabs>
      </Box>
      {tabvalue === 0 ? (
        <Images images={values?.images} />
      ) : tabvalue === 1 ? (
        <Videos videos={values?.videos} />
      ) : tabvalue === 2 ? (
        <Audios audios={values?.audios} />
      ) : tabvalue === 3 ? (
        <Attachments attachments={values?.documents} />
      ) : (
        <Links links={values?.urls} />
      )}
    </Box>
  );
}
